import styled from "styled-components";

export const CardGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;

  & > div {
    flex: 1 1 auto;
    width: 100%;
  }
`;
